<div class="page">
  <div class="row">
    <div style="padding: 0" class="col-md-3">
      <div class="side-tabs">
        <div class="side-title">{{ 'store.settings.title' | translate }}</div>

        <div class="tabs-con">
          <div (click)="updateSelectedTag(1)" [ngClass]="{'selected-tab' : selectedTab ===1}" class="tab">
            {{ 'store.settings.tabs.storeDetails' | translate }}
          </div>
          <div (click)="updateSelectedTag(2)" [ngClass]="{'selected-tab' : selectedTab ===2}" class="tab">
            {{ 'store.settings.tabs.storeLocation' | translate }}
          </div>
          <div (click)="updateSelectedTag(3)" [ngClass]="{'selected-tab' : selectedTab ===3}" class="tab">
            {{ 'store.settings.tabs.accountDetails' | translate }}
          </div>
          <div (click)="updateSelectedTag(4)" [ngClass]="{'selected-tab' : selectedTab ===4}" class="tab">
            {{ 'store.settings.tabs.transferDetails' | translate }}
          </div>
          <div (click)="updateSelectedTag(5)" [ngClass]="{'selected-tab' : selectedTab ===5}" class="tab">
            {{ 'store.settings.tabs.ecommerce' | translate }}
          </div>
        </div>

      </div>
    </div>
    <div *ngIf="selectedTab === 1" class="col-md-6">
      <div class="sec-title">
        {{ 'store.settings.tabs.storeDetails' | translate }}
      </div>
      <input style="display: none" type="file" #logoUploader accept="image/*" (change)="onLogoChange($event)">

      <div class="sec-imgs-container">
        <div class="header-con">
          <div class="sub-header">{{ 'store.settings.storeProfile' | translate }}</div>
          <button class="header-btn" (click)="logoUploader.click()">{{ 'store.settings.addImage' | translate }}</button>
        </div>
        <div class="img-upload" AreaDragDrop (files)="onLogoChangeDropped($event)">
          <img [src]="storeDetails.imageURL || 'assets/images/image.png'" alt="">
          <div>{{ 'store.settings.dropImage' | translate }}</div>

        </div>

        <div class="label-sec">
          {{ 'store.settings.storeName' | translate }}
        </div>
        <input [(ngModel)]="storeDetails['name']" class="input-sec" type="text">

        <div class="label-sec">
          {{ 'store.settings.category' | translate }}
        </div>

        <select (change)="onSelectCategory($event)" class="select-category">
          <option [selected]="category.id === storeDetails.category.id" *ngFor="let category of categoryList"
                  [value]="category.id">{{category.name}}</option>
        </select>
        <div class="label-sec">
          {{ 'common.currency' | translate }}
        </div>
        <input disabled [(ngModel)]="storeDetails['currency']" class="input-sec" type="text" name="" id="">

        <div class="label-sec">
          {{ 'store.settings.paymentCode' | translate }}
        </div>
        <input
          disabled
          class="input-sec settings-payment-code"
          type="text"
          [value]="data?.paymentCode || ('store.settings.paymentCodeNone' | translate)">
        <div class="field-hint">{{ 'store.settings.paymentCodeHint' | translate }}</div>

        <div class="label-sec">
          {{ 'store.settings.storeDescription' | translate }}
        </div>
        <textarea [(ngModel)]="storeDetails['description']" class="sec-textarea">

        </textarea>
      </div>
      <div class="save-btn-sec">
        <button (click)="onSaveDetails()">{{ 'common.saveChanges' | translate }}</button>
      </div>
    </div>
    <div *ngIf="selectedTab === 2" class="col-md-6">
      <div class="sec-title">
        {{ 'store.settings.tabs.storeLocation' | translate }}
      </div>
      <div class="sec-imgs-container">
        <div class="label-sec">{{ 'store.settings.country' | translate }}</div>
        <select
          [(ngModel)]="countryId"
          class="select-category" name="cars" id="cars">
          <option [selected]="countryId == item.id" *ngFor="let item of countriesList" [value]="item.id">
            {{item?.name}}
          </option>
        </select>
        <div class="label-sec ">{{ 'store.settings.posLocation' | translate }}</div>
        <input type="text" [value]="address" class="form-control input-sec" (keydown.enter)="$event.preventDefault()"
               id="serach"
               [placeholder]="'store.settings.searchLocation' | translate" autocorrect="off" autocapitalize="off" spellcheck="off" #search>
        <div class="map-container">
          <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
            <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"
                        (dragEnd)="markerDragEnd($event)"></agm-marker>
          </agm-map>
        </div>
      </div>
      <div class="save-btn-sec">
        <button (click)="onSaveLocation()">{{ 'common.saveChanges' | translate }}</button>
      </div>
    </div>
    <div *ngIf="selectedTab === 3" class="col-md-6">
      <div class="sec-title">
        {{ 'store.settings.tabs.accountDetails' | translate }}
      </div>
      <div class="sec-imgs-container">
        <div class="name-input">
          <div class="label-sec">
            {{ 'store.settings.firstName' | translate }}
          </div>
          <div class="label-sec">
            {{ 'store.settings.lastName' | translate }}
          </div>
        </div>
        <div class="name-input">
          <input [(ngModel)]="accountDetails['firstName']" class="input-sec" type="text">
          <input [(ngModel)]="accountDetails['lastName']" class="input-sec" type="text">

        </div>
        <div class="label-sec">
          {{ 'store.settings.email' | translate }}
        </div>
        <input disabled [(ngModel)]="accountDetails['emailAddress']" class="input-sec" type="text">
        <div class="label-sec">
          {{ 'store.settings.contactNumber' | translate }}
        </div>
        <input [(ngModel)]="accountDetails['contactNumber']" class="input-sec ltr-input" type="text">
      </div>
      <div class="save-btn-sec">
        <button (click)="onSaveAccountDetails()">{{ 'common.saveChanges' | translate }}</button>
      </div>
    </div>
    <div *ngIf="selectedTab === 4" class="col-md-6">
      <div class="sec-title">
        {{ 'store.settings.tabs.transferDetails' | translate }}
      </div>
      <div class="sec-imgs-container">
        <div class="label-sec">
          {{ 'store.settings.country' | translate }}
        </div>
        <input [(ngModel)]="transferDetails['countryCode']" class="input-sec" type="text">
        <div class="label-sec">
          {{ 'store.settings.bankName' | translate }}
        </div>
        <input [(ngModel)]="transferDetails['bankName']" class="input-sec" type="text">
        <div class="label-sec">
          {{ 'store.settings.iban' | translate }}
        </div>
        <input [(ngModel)]="transferDetails['IBAN']" class="input-sec ltr-input" type="text">
      </div>


      <div class="save-btn-sec">
        <button (click)="onSaveTransferDetails()">{{ 'common.saveChanges' | translate }}</button>
      </div>
    </div>
    <div *ngIf="selectedTab === 5" class="col-md-6">
      <div class="sec-title">
        {{ 'store.settings.tabs.ecommerce' | translate }}
      </div>
      <div class="sec-imgs-container">
        <div class="settings-group">
          <div class="setting-item">
            <div class="setting-label">
              <span class="label-title">{{ 'store.settings.cod' | translate }}</span>
              <span class="label-description">{{ 'store.settings.codHint' | translate }}</span>
            </div>
            <div class="toggle-switch">
              <input
                type="checkbox"
                [ngModel]="ecommerceStoreConfig.allowCod"
                (ngModelChange)="ecommerceStoreConfig.allowCod = $event">
            </div>
          </div>

          <div class="setting-item">
            <div class="setting-label">
              <span class="label-title">{{ 'store.settings.delivery' | translate }}</span>
              <span class="label-description">{{ 'store.settings.deliveryHint' | translate }}</span>
            </div>
            <div class="toggle-switch">
              <input
                type="checkbox"
                [ngModel]="ecommerceStoreConfig.allowDelivery"
                (ngModelChange)="ecommerceStoreConfig.allowDelivery = $event">
            </div>
          </div>

          <!-- Delivery Hours Section -->
          <div *ngIf="ecommerceStoreConfig.allowDelivery" class="availability-section" [class.minimized]="minimizedSections['DELIVERY']">
            <div class="section-header">
              <div class="header-left">
                <h4>{{ 'store.settings.deliveryHours' | translate }}</h4>
                <span class="schedule-count" *ngIf="minimizedSections['DELIVERY']">
                  {{ 'store.settings.daysScheduled' | translate: { count: getSchedulesByType('DELIVERY').length } }}
                </span>
              </div>
              <div class="button-group">
                <button class="minimize-btn" (click)="toggleSection('DELIVERY')">
                  <i class="fas" [class.fa-chevron-down]="!minimizedSections['DELIVERY']" [class.fa-chevron-up]="minimizedSections['DELIVERY']"></i>
                </button>
                <button class="fill-btn"
                        *ngIf="!minimizedSections['DELIVERY'] && getSchedulesByType('DELIVERY').length > 0 && canAddMoreDays('DELIVERY')"
                        (click)="fillRemainingDays('DELIVERY')">
                  <i class="fas fa-copy"></i> {{ 'store.settings.fillAllDays' | translate }}
                </button>
                <button class="add-btn"
                        *ngIf="!minimizedSections['DELIVERY']"
                        [disabled]="!canAddMoreDays('DELIVERY')"
                        [class.disabled]="!canAddMoreDays('DELIVERY')"
                        (click)="addAvailabilitySchedule('DELIVERY')">
                  <i class="fas fa-plus"></i> {{ 'store.settings.addDay' | translate }}
                </button>
              </div>
            </div>
            <div class="schedules-container" *ngIf="!minimizedSections['DELIVERY']">
              <div *ngFor="let schedule of getSchedulesByType('DELIVERY'); let i = index" class="schedule-item">
                <div class="schedule-row">
                  <div class="day-select">
                    <select [(ngModel)]="schedule.day"
                            (ngModelChange)="onDayChange('DELIVERY', i, $event)"
                            class="select-day"
                            [class.error]="dayError[i]">
                      <option *ngFor="let day of getAvailableDays('DELIVERY', i)" [value]="day">{{day}}</option>
                    </select>
                    <div *ngIf="dayError[i]" class="error-message">{{dayError[i]}}</div>
                  </div>

                  <div *ngIf="!schedule.isActive" class="off-status">{{ 'store.settings.off' | translate }}</div>

                  <div *ngIf="schedule.isActive" class="time-inputs">
                    <div class="time-input">
                      <i class="far fa-clock"></i>
                      <input type="time" [(ngModel)]="schedule.startTime" (blur)="schedule.startTime = formatTimeWithSeconds(schedule.startTime)">
                    </div>
                    <span>{{ 'store.settings.to' | translate }}</span>
                    <div class="time-input">
                      <i class="far fa-clock"></i>
                      <input type="time" [(ngModel)]="schedule.endTime" (blur)="schedule.endTime = formatTimeWithSeconds(schedule.endTime)">
                    </div>
                  </div>

                  <div class="schedule-actions">
                    <button class="status-btn" (click)="updateScheduleStatus(i)">
                      {{ (schedule.isActive ? 'store.settings.markAsOff' : 'store.settings.setHours') | translate }}
                    </button>
                    <button class="remove-btn" (click)="removeAvailabilitySchedule(i, 'DELIVERY')">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="setting-item">
            <div class="setting-label">
              <span class="label-title">{{ 'store.settings.deliveryRate' | translate }}</span>
            </div>
            <input
              type="number"
              step="0.01"
              class="input-sec"
              [(ngModel)]="ecommerceStoreConfig.deliveryRate">
          </div>

          <div class="setting-item">
            <div class="setting-label">
              <span class="label-title">{{ 'store.settings.inStoreOrder' | translate }}</span>
              <span class="label-description">{{ 'store.settings.inStoreOrderHint' | translate }}</span>
            </div>
            <div class="toggle-switch">
              <input
                type="checkbox"
                [ngModel]="ecommerceStoreConfig.allowInStoreOrder"
                (ngModelChange)="ecommerceStoreConfig.allowInStoreOrder = $event">
            </div>
          </div>

          <!-- In-Store Hours Section -->
          <div *ngIf="ecommerceStoreConfig.allowInStoreOrder" class="availability-section" [class.minimized]="minimizedSections['IN_STORE']">
            <div class="section-header">
              <div class="header-left">
                <h4>{{ 'store.settings.storeHours' | translate }}</h4>
                <span class="schedule-count" *ngIf="minimizedSections['IN_STORE']">
                  {{ 'store.settings.daysScheduled' | translate: { count: getSchedulesByType('IN_STORE').length } }}
                </span>
              </div>
              <div class="button-group">
                <button class="minimize-btn" (click)="toggleSection('IN_STORE')">
                  <i class="fas" [class.fa-chevron-down]="!minimizedSections['IN_STORE']" [class.fa-chevron-up]="minimizedSections['IN_STORE']"></i>
                </button>
                <button class="fill-btn"
                        *ngIf="!minimizedSections['IN_STORE'] && getSchedulesByType('IN_STORE').length > 0 && canAddMoreDays('IN_STORE')"
                        (click)="fillRemainingDays('IN_STORE')">
                  <i class="fas fa-copy"></i> {{ 'store.settings.fillAllDays' | translate }}
                </button>
                <button class="add-btn"
                        *ngIf="!minimizedSections['IN_STORE']"
                        [disabled]="!canAddMoreDays('IN_STORE')"
                        [class.disabled]="!canAddMoreDays('IN_STORE')"
                        (click)="addAvailabilitySchedule('IN_STORE')">
                  <i class="fas fa-plus"></i> {{ 'store.settings.addDay' | translate }}
                </button>
              </div>
            </div>
            <div class="schedules-container" *ngIf="!minimizedSections['IN_STORE']">
              <div *ngFor="let schedule of getSchedulesByType('IN_STORE'); let i = index" class="schedule-item">
                <div class="schedule-row">
                  <div class="day-select">
                    <select [(ngModel)]="schedule.day"
                            (ngModelChange)="onDayChange('IN_STORE', i, $event)"
                            class="select-day"
                            [class.error]="dayError[i]">
                      <option *ngFor="let day of getAvailableDays('IN_STORE', i)" [value]="day">{{day}}</option>
                    </select>
                    <div *ngIf="dayError[i]" class="error-message">{{dayError[i]}}</div>
                  </div>

                  <div *ngIf="!schedule.isActive" class="off-status">{{ 'store.settings.off' | translate }}</div>

                  <div *ngIf="schedule.isActive" class="time-inputs">
                    <div class="time-input">
                      <i class="far fa-clock"></i>
                      <input type="time" [(ngModel)]="schedule.startTime" (blur)="schedule.startTime = formatTimeWithSeconds(schedule.startTime)">
                    </div>
                    <span>{{ 'store.settings.to' | translate }}</span>
                    <div class="time-input">
                      <i class="far fa-clock"></i>
                      <input type="time" [(ngModel)]="schedule.endTime" (blur)="schedule.endTime = formatTimeWithSeconds(schedule.endTime)">
                    </div>
                  </div>

                  <div class="schedule-actions">
                    <button class="status-btn" (click)="updateScheduleStatus(i)">
                      {{ (schedule.isActive ? 'store.settings.markAsOff' : 'store.settings.setHours') | translate }}
                    </button>
                    <button class="remove-btn" (click)="removeAvailabilitySchedule(i, 'IN_STORE')">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="save-btn-sec">
        <button (click)="onSaveEcommerceSettings()">{{ 'common.saveChanges' | translate }}</button>
      </div>
    </div>
  </div>
</div>
<ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
